import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'

const WhatWeDo = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <h1 className={commonStyles.heading}>What we do</h1>
      <div className={commonStyles.subheading}>Our vision is to liberate creativity</div>
      <div className={commonStyles.textContent}>
        <div className={commonStyles.paragraph}>
          By radically simplifying music licensing and making it fast, easy and affordable, we unlock creative opportunities for the world’s
          music creators, new revenue for the original creators, and change the way the world can make music
        </div>
        <div className={commonStyles.paragraph}>
          Through Tracklib, artists and producers can dig deep into crates of old, new, popular and obscure music from all over the world.
          Original artists, creators and rightsholders benefit by generating revenue from their catalogs and finding a new audience for
          their music
        </div>
      </div>
    </motion.div>
  )
}

export default WhatWeDo
